var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import messages from '@/modules/tasks/weekplanner/weekPlannerMessages';
var WeekPlannerPeriods = function (_a) {
    var _b = _a.filters, filters = _b === void 0 ? {} : _b, onChangeDate = _a.onChangeDate;
    var executionDateFrom = filters.executionDateFrom, executionDateUntil = filters.executionDateUntil;
    var currentWeek = moment.utc().startOf('isoWeek');
    var currentWeekEnd = moment.utc().endOf('isoWeek');
    return (_jsxs("div", __assign({ className: "btn-group btn-group-justified" }, { children: [_jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () {
                    return onChangeDate(moment(executionDateFrom).subtract(1, 'week'), executionDateUntil ? moment(executionDateUntil).subtract(1, 'week') : null);
                } }, { children: _jsx(FormattedMessage, __assign({}, messages.SubtractOneWeek)) })), _jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () { return onChangeDate(moment(currentWeek), moment(currentWeekEnd)); } }, { children: _jsx(FormattedMessage, __assign({}, messages.CurrentWeek)) })), _jsx("button", __assign({ type: "button", className: "btn btn-default", onClick: function () {
                    return onChangeDate(moment(executionDateFrom).add(1, 'week'), executionDateUntil ? moment(executionDateUntil).add(1, 'week') : null);
                } }, { children: _jsx(FormattedMessage, __assign({}, messages.AddOneWeek)) }))] })));
};
export default WeekPlannerPeriods;
